<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <notification-config>
        </notification-config> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import notificationConfig from './todo-notification-config'
export default {
    components: {
        notificationConfig
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-settings/base-notification-config.vue